"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const classnames_1 = __importDefault(require("classnames"));
const common_scss_1 = __importDefault(require("../../shared/common.scss"));
const constants_1 = require("../../shared/constants");
const a11y_1 = require("../../../../../core/commons/a11y");
const utils_1 = require("../../../../../core/commons/utils");
const ResponsiveBox_scss_1 = __importDefault(require("./ResponsiveBox.scss"));
const getAriaLabel = (translate) => {
    return translate
        ? translate(constants_1.ARIA_LABEL_NAMESPACE, constants_1.ARIA_LABEL_KEY, constants_1.ARIA_LABEL_DEFAULT)
        : constants_1.ARIA_LABEL_DEFAULT;
};
// This container is used in responsive site
const ResponsiveBox = (props, ref) => {
    const { id, className, containerRootClassName = '', children, role, onClick, onDblClick, onFocus, onBlur, onMouseEnter, onMouseLeave, hasPlatformClickHandler, translate, a11y = {}, ariaAttributes = {}, tabIndex, } = props;
    const { 'aria-label-interactions': ariaLabelInteractions } = a11y, a11yAttr = __rest(a11y, ['aria-label-interactions']);
    if (ariaLabelInteractions) {
        a11yAttr['aria-label'] = getAriaLabel(translate);
    }
    const rootElementRef = React.useRef(null);
    React.useImperativeHandle(ref, () => {
        return {
            focus: () => {
                var _a;
                (_a = rootElementRef.current) === null || _a === void 0 ? void 0 : _a.focus();
            },
            blur: () => {
                var _a;
                (_a = rootElementRef.current) === null || _a === void 0 ? void 0 : _a.blur();
            },
        };
    });
    return (React.createElement("div", Object.assign({ id: id }, (0, utils_1.getDataAttributes)(props), { ref: rootElementRef }, a11yAttr, (0, a11y_1.getAriaAttributes)(Object.assign(Object.assign({}, ariaAttributes), { tabIndex, role })), { className: (0, classnames_1.default)(className, ResponsiveBox_scss_1.default.root, containerRootClassName, {
            [common_scss_1.default.clickable]: hasPlatformClickHandler,
        }), onDoubleClick: onDblClick, onClick: onClick, onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave }),
        React.createElement("div", { className: ResponsiveBox_scss_1.default.bg }),
        children() // contains: (1) ResponsiveContainer with relative children, (2) DynamicStructureContainer with pinned children
    ));
};
exports.default = React.forwardRef(ResponsiveBox);
//# sourceMappingURL=ResponsiveBox.skin.js.map